export const toUnixTs = (date: Date) => Math.floor(date.getTime() / 1000);
export const unixTsNow = () => toUnixTs(new Date());
